import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

export default function NotFound() {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                Gitmeye çalıştığınız sayfa bulunamadı
            </Header>
            <Segment.Inline>
                <Button as={Link} to='/dashboard' primary>
                    Ana sayfaya dön
                </Button>
            </Segment.Inline>
        </Segment>
    )
}